"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var clsx_1 = __importDefault(require("clsx"));
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var BackDropSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  /* Remove grey highlight */\n  -webkit-tap-highlight-color: transparent;\n  /* Disable scroll capabilities.*/\n  touch-action: none;\n\n  &._ndsBackDrop--invisible {\n    background: transparent;\n  }\n"], ["\n  z-index: ", ";\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  /* Remove grey highlight */\n  -webkit-tap-highlight-color: transparent;\n  /* Disable scroll capabilities.*/\n  touch-action: none;\n\n  &._ndsBackDrop--invisible {\n    background: transparent;\n  }\n"])), function (props) { return props.theme.zIndex.topLayer - 1; }, function (props) { return props.theme.ColorBackgroundBackDrop; });
var BackDrop = function (props) {
    var forwardedRef = props.forwardedRef, classNameProp = props.className, invisible = props.invisible, open = props.open, others = __rest(props, ["forwardedRef", "className", "invisible", "open"]);
    return open ? (react_1.default.createElement(BackDropSC, __assign({ ref: forwardedRef, className: clsx_1.default(classNameProp, {
            '_ndsBackDrop--invisible': invisible
        }), "aria-hidden": true }, others))) : null;
};
BackDrop.propTypes = {
    forwardedRef: prop_types_1.default.any,
    className: prop_types_1.default.string,
    invisible: prop_types_1.default.bool,
    open: prop_types_1.default.bool.isRequired
};
BackDrop.defaultProps = {
    forwardedRef: react_1.default.createRef(),
    className: undefined,
    invisible: false
};
exports.default = reactHelpers_1.withForwardedRef(BackDrop);
var templateObject_1;
//# sourceMappingURL=BackDrop.js.map